module.exports = __webpack_public_path__ + "static/media/my-favourites.37822a3f.svg";